module.exports = "<div class=\"grid-selector\">\n\t<div class=\"header\">\n\t\t<h4>{{title}}</h4>\n\t\t<p>{{helpText}}</p>\n\t</div>\n\t<div class=\"grid-items\">\n\t\t<div class=\"grid-item\" *ngFor=\"let item of items\" (click)=\"selected.next(item)\">\n\t\t\t<div class=\"icon\"><i [ngClass]=\"item.icon\"></i></div>\n\t\t\t<div class=\"description\">\n\t\t\t\t<div class=\"name\">{{(item[nameField] || item) | labelize | capitalize}}</div>\n\t\t\t\t<div class=\"subtext\">{{item[subtextField]}}</div>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./~/@c4/programming/src/app/advanced/grid-selector/grid-selector.component.html
// module id = 1515
// module chunks = 2